import { Tabs } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import PPPageHeader from '../../../components/pageHeader/PPPageHeader';
import Facts from '../Facts';
import Notes from '../Notes';
import Detail from './Detail';

const ALL_TABS = [
  { key: 'detail', label: 'Тооллого дэлгэрэнгүй' },
  { key: 'fact', label: 'Баримт' },
  { key: 'note', label: 'Тэмдэглэл' },
];

const LIST_PATH = '/merchant/inventory/control';

const InventoryListWithDetail = () => {
  const history = useHistory();
  const location = useLocation();
  const { controlId } = useParams();

  const initialTab = new URLSearchParams(location.search).get('tab') || ALL_TABS[0].key;
  const getValidKey = (key) => (ALL_TABS.find((i) => i.key === key) ? key : ALL_TABS[0].key);

  const [currentKey, setCurrentKey] = useState(() => getValidKey(initialTab));
  const [detail, setDetail] = useState({});
  /**
   * Дэлгэрэнгүй ачаалагдаж дуустал таб бүр хоосон харагддаг байсан — хэрэглэгч
   * ачаалж байгаа эсэх, эсвэл өгөгдөл байхгүй эсэхийг ойлгох боломжгүй байв.
   */
  const [loading, setLoading] = useState(true);

  const getOrderDetail = (id = controlId) => {
    setLoading(true);
    axios
      .get(`/api/v1/request/${id}?type=invCount`)
      .then(({ data = {} }) => {
        setDetail(data.statusCode === 200 ? data.result : {});
      })
      .catch((err) => {
        console.error('getInventoryDetail: ', err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getOrderDetail(controlId);
    //eslint-disable-next-line
  }, [controlId]);

  const goBack = () =>
    history.push({
      pathname: LIST_PATH,
      search: location.state?.search,
    });

  const routes = [
    {
      to: {
        pathname: location.state?.source ?? LIST_PATH,
        search: location.state?.search,
      },
      breadcrumbName: 'Тооллого',
    },
    {
      path: 'first',
      breadcrumbName: 'Тооллого дэлгэрэнгүй',
    },
  ];

  const onChange = (key) => {
    setCurrentKey(key);
    history.replace({
      pathname: `/merchant/inventory/controls/${controlId}`,
      search: `?tab=${key}`,
      state: location.state,
    });
  };

  return (
    <div>
      <PPPageHeader title="Тооллого дэлгэрэнгүй" breadcrumb={{ routes }} onBack={goBack} />
      <Tabs
        activeKey={currentKey}
        onChange={onChange}
        items={ALL_TABS}
        tabBarStyle={{ marginBottom: 0, margin: '0', padding: '0 12px' }}
      />

      {/* Таб бүр эргэн тойрны зайгаа өөрөө агуулна тул wrapper-гүй */}
      {currentKey === 'detail' && (
        <Detail detail={detail} loading={loading} refreshDetail={() => getOrderDetail(controlId)} />
      )}
      {currentKey === 'fact' && (
        <Facts facts={detail} loading={loading} getDetailData={getOrderDetail} />
      )}
      {currentKey === 'note' && (
        <Notes notes={detail} loading={loading} getDetailData={() => getOrderDetail(controlId)} />
      )}
    </div>
  );
};

export default InventoryListWithDetail;
